var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHKey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 84,
    viewBox: "0 0 108 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 29.1245V75C1 79.4183 4.58172 83 9 83H99C103.418 83 107 79.4183 107 75V29.1245C107 27.7323 106.633 26.3739 106.005 25.1311C101.957 17.1159 95.7888 1 87.5 1H20.5C12.2112 1 6.04285 17.1159 1.99505 25.1311C1.36745 26.3739 1 27.7323 1 29.1245Z",
    fill: "#393D4C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 1C12.2112 1 6.04285 17.1159 1.99505 25.1311C1.36745 26.3739 1 27.7323 1 29.1245V75C1 79.4183 4.58172 83 9 83H99C103.418 83 107 79.4183 107 75V29.1245C107 27.7323 106.633 26.3739 106.005 25.1311C101.957 17.1159 95.7888 1 87.5 1M13 57V9C13 4.58172 16.5817 1 21 1H87C91.4183 1 95 4.58172 95 9V57C95 61.4183 91.4183 65 87 65H21C16.5817 65 13 61.4183 13 57Z",
    stroke: "white",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18 64.5L13 83",
    stroke: "white",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M90 64.5L95 83",
    stroke: "white",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 59L1 75.5",
    stroke: "white",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M94.5 59L107 75.5",
    stroke: "white",
    strokeWidth: 2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M60.8877 25.9199V41.9999H57.6237V35.3999H49.9437V41.9999H46.6797V25.9199H49.9437V32.4479H57.6237V25.9199H60.8877Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHKey);
export default __webpack_public_path__ + "static/media/h-key.d74de092553666686931434f8a498ac0.svg";
export { ForwardRef as ReactComponent };